'use strict';

var $ = require('jquery');
var cart = require('../cart');
var availability = require('../../../pages/product/availability');
var image = require('./image');
var variant = require('../../../pages/product/variant');
var variationValidation = require('../../../pages/product/validVariation');
var minicart = require('../minicart').miniCart;
var product;
const {updateAddToCartButtonState} = require('../../../pages/product/addToCart');

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
    var $pdpMain = $('#pdpMain');

    // addToCart();
    $pdpMain.on('click', '.add-to-cart', function (event) {
        var $form = $(event.target).closest('form');
        if ($form.length) {
            cart.addItemToCart($form[0]).then(function (response) {
                var chunks = response.split('%$%$%$SPLITME%$%$%$');
                var miniCartContent = chunks[0];
                var cartContent = chunks[2];
                var itemCount;
                if (chunks[1]) {
                    try {
                        var data = JSON.parse(chunks[1]);
                        if (data) {
                            itemCount = data.qty;
                        }
                    } catch (e) {
                        // console.log("could not parse minicart json");
                    }
                }

                // update minicart
                minicart.update(miniCartContent, itemCount);
                // show cart in flyin.
                cart.showCartAddedConfirmation(cartContent);
            });
        }
    });
    availability();
    variant({uniform: false});
    image();
    variationValidation.init();

    // product options
    $pdpMain.on('change', '.product-options select', function () {
        var $salesPrice = $pdpMain.find('.product-add-to-cart .price-sales');
        var $selectedItem = $(this).children().filter(':selected').first();
        $salesPrice.text($selectedItem.data('combined'));
    });

    // prevent default behavior of thumbnail link and add this Button
    $pdpMain.on('click', '.thumbnail-link, .unselectable a', function (e) {
        e.preventDefault();
    });

    updateAddToCartButtonState(false, false);
}

product = {
    initializeEvents: initializeEvents,
    init: function () {
        initializeEvents();
    }
};

module.exports = product;
